import { connect } from 'react-redux'
import * as api from '../../../actions/api'
import * as actions from '../../../actions'
import { EventListCard } from '../components'
import { authorType } from '../../../constants'

const mapStateToProps = (state, ownProps) => {
  const { auth0, isAuthStateChange } = state.authentication
  const { records, isFetching, ready } = state.eventListCard
  const { search } = ownProps
  const { language } = state.user
  var eventRecords
  if (search !== undefined){
    if ('author' in search) {
      eventRecords = records.filter(record => {
        return Boolean(
          record.authorType === parseInt(authorType.CONTRIBUTOR, 10) &&
          record.author.userName === search.author
        )
      })
    }
    if ('attend' in search) {
      eventRecords = records.filter(record => {
        return Boolean(
          record.attend !== undefined &&
          record.attend.some(user => user.userName === search.attend)
      )})
    }
    if ('interest' in search) {
      eventRecords = records.filter(record => {
        return Boolean(
          record.interest !== undefined &&
          record.interest.some(user => user.userName === search.interest)
      )})
    }
  }
  else {
    eventRecords = records
  }

  return  ({
    auth0,
    isAuthStateChange,
    isFetching,
    ready,
    recordsCardContentSProps: {
      records: eventRecords,
      fullWidth: ownProps.fullWidth,
      disabledMonthlyCard: ownProps.disabledMonthlyCard,
    },
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      dispatch(actions.eventListCard.requestSelectEvent())
      dispatch(api.event.select(
        {
          startDate: Date.now(),
        },
        (response) => {
          dispatch(actions.eventListCard.responseSelectEvent(response))
      }))
    },
    unmount: () => {

    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventListCard)


// WEBPACK FOOTER //
// ./src/Pages/Event/containers/EventListCard.js